import { render, staticRenderFns } from "./RadioImageBase.vue?vue&type=template&id=591b0976&scoped=true&"
import script from "./RadioImageBase.vue?vue&type=script&lang=js&"
export * from "./RadioImageBase.vue?vue&type=script&lang=js&"
import style0 from "./RadioImageBase.vue?vue&type=style&index=0&id=591b0976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b0976",
  null
  
)

export default component.exports